import { Environment, EnvironmentCodePath, EnvironmentCountry, EnvironmentLocale } from '@cfp/core';
import { EnvironmentCodeDTO } from 'csr-login-app';

export const environment: Environment = {
  production: true,
  environmentCode: {
    dto: EnvironmentCodeDTO.LBG,
    path: EnvironmentCodePath.LBG
  },
  appName: 'Lloyds Bank Green Buildings Tool',
  showTitle: false,
  showInPartnershipWith: true,
  customerName: 'Lloyds Bank',
  email: 'lloydsbank@greenbuildingstool.com',
  localeId: EnvironmentLocale.EN_GB,
  country: EnvironmentCountry.UK,
  useConstructionPeriod: true,
  customerAssetsDir: './assets/styling/',
  measureImagesDir: './assets/img/measures/',
  api: '/csr/api/',
  apiV1: '/csr/api/v1/',
  apiV2: '/csr/api/v2/',
  cfpUrl: 'cfpgreenbuildings.com',
  privacyUrl: 'https://cfp.nl/en/privacy-statement/',
  googleMapsCenter: { lat: 54.337572, lng: -3.457936, zoom: 5 },
  showBuildingPropertySummary: true,
  showUserAreaUnitSettings: true,
  showBuildingNotifications: true,
  useDeprecatedAddBuildingPage: true,
  images: {
    logoNavbar: 'lloyds-logo.svg',
    loginLogoNavbar: 'lloyds-logo.svg',
    loginBackground: 'background.jpg',
    logoReport: 'lloyds-logo.svg'
  },
  icons: {
    iconSavings: 'icon-savings',
    iconCo2Reduction: 'icon-co2-reduction',
    iconSubsidy: 'icon-subsidy',
    iconReturnInvestment: 'icon-return-investment',
    iconEfficiency: 'icon-return-investment',
    iconYearlyMaintenanceSavings: 'icon-savings',
    iconParisProof: 'icon-eiffel',
    iconConsumptionReduction: 'fas fa-bolt'
  },
  defaultRoute: '/welcome',
  defaultModuleRoute: 'energy',
  defaultRelationManagementRoute: 'relation-management',
  loginRoute: '/welcome',
  modules: {
    clientportal: false,
    onboarding: false,
    welcome: true,
    customerregistration: false,
    consultantWizard: false
  },
  demo: {
    addBuilding: true
  },
  components: {
    unlockAccount: false,
    ssoSaml: true,
    navbar: true,
    changeInvestment: true,
    hideNavBarNavs: true,
    navbarTheme: 'dark',
    languages: false,
    greenFinancing: false,
    relationManagerInfoButton: true,
    measureOfferRequestButton: true,
    scenarioButtons: true,
    scenarioTwoDegrees: false,
    scenarioRecognizedMeasures: false,
    scenarioFiveYear: true,
    showInvestor: false,
    showIndexImprovement: false,
    showLabelImprovementInfoText: true,
    savingsM2: true,
    co2ConsumptionReductionPercentage: false,
    extendedRelationManagerForm: false,
    measureSubsidy: true,
    showBuildingDescription: true,
    forcePasswordChange: false,
    shareEnerymonitoringGraphs: true,
    showFaq: true,
    portfolioFinancing: false,
    showRecognisedMeasureCheck: false,
    showParisProof: false,
    showNavBarLinks: true,
    reportSuspiciousActivityLink: 'https://www.lloydsbank.com/business/contact-us.html#reportfraud',
    useCard: true,
    navBack: true,
    navPortfolio: false,
    portfolioBuildingsShowRegionFilter: true,
    relationManagementAllowBuildingImport: true,
    relationManagementAllowAddBuilding: true,
    relationManagementShowCustomerSettings: false,
    showRelationManagementButtonInNavbar: true,
    relationManagementShowCustomerBusinessKey: true,
    relationManagementShowDefaultDemoPortfolioInQuickLinks: true,
    showLoginUsingSso: true,
    portfolioBuildingsSummaryCoverImage: 'cover.jpg',
    hidePasswordResetTermsOfUse: true
  },
  labelFilters: {
    a: true,
    b: true,
    c: true,
    d: false,
    e: false
  }
};
